import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Typography,
  Divider,
  Row,
  Col,
  Space,
  message,
} from "antd";
import { UserOutlined, PhoneOutlined } from "@ant-design/icons";
import apiRequest from "src/common/utils/apiRequest";
import LoadingPreview from "src/common/components/LoadingPreview";

const { Text, Title } = Typography;

const ContactAndAddress: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const onFinish = async () => {
    setSaving(true);
    try {
      await form.validateFields();

      const API_REQUEST = new apiRequest(
        "user/profile/setting/contact/edit",
        true
      );

      await API_REQUEST.send(
        form.getFieldsValue(),
        (response: { status: string; message: string }) => {
          if (response.status === "success") {
            message.success(response.message);
          } else {
            message.error(response.message);
          }
        }
      );
    } catch (errorInfo: any) {
      message.error(errorInfo.errorFields[0].errors[0]);
    }
    setSaving(false);
  };

  useEffect(() => {
    const getData = () => {
      const API_REQUEST = new apiRequest(
        "user/profile/setting/contact/get",
        true
      );

      API_REQUEST.send(
        {},
        (response: { status: string; data: any; message: string }) => {
          if (response.status === "success") {
            form.setFieldsValue(response.data);
            setLoading(false);
          } else {
            message.error(response.message);
          }
        }
      );
    };

    getData();
  }, []);

  return (
    <div>
      <Title level={3} style={{ marginTop: "0" }}>
        Contact and Address
      </Title>
      <Text type="secondary">Update your contact details and addresses</Text>

      <Divider />
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {loading ? (
          <LoadingPreview />
        ) : (
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Permanent Address */}
            <div style={{ marginBottom: 12 }}>
              <Text strong>Permanent Address</Text>
              <Form.Item
                name="permanent_address"
                rules={[{ required: true, message: "Required" }]}
                style={{ marginBottom: 0, marginTop: 8 }}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Enter full permanent address"
                  style={{ resize: "none" }}
                  allowClear
                />
              </Form.Item>
            </div>

            {/* Mailing Address */}
            <div style={{ marginBottom: 12 }}>
              <Text strong>Mailing Address</Text>
              <Form.Item
                name="mailing_address"
                rules={[{ required: true, message: "Required" }]}
                style={{ marginBottom: 0, marginTop: 8 }}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Enter full mailing address"
                  style={{ resize: "none" }}
                  allowClear
                />
              </Form.Item>
            </div>

            {/* Emergency Contact */}
            <div>
              <Text strong>Emergency Contact</Text>
              <Row gutter={16} style={{ marginTop: 8 }}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="emergency_contact_name"
                    label={<Text type="secondary">Contact Person</Text>}
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Input
                      prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                      placeholder="Full name"
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="emergency_contact_phone"
                    label={<Text type="secondary">Contact Number</Text>}
                    rules={[
                      { required: true, message: "Required" },
                      { pattern: /^[+0-9\s-]+$/, message: "Invalid format" },
                    ]}
                  >
                    <Input
                      prefix={<PhoneOutlined style={{ color: "#bfbfbf" }} />}
                      placeholder="Phone number"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Divider style={{ margin: "12px 0" }} />

            <Form.Item style={{ marginTop: 8 }}>
              <Button
                type="primary"
                loading={saving}
                htmlType="submit"
                style={{ width: 120 }}
              >
                Save Changes
              </Button>
            </Form.Item>
          </Form>
        )}
      </Space>
    </div>
  );
};

export default ContactAndAddress;
